import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const url = environment.api;


@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private http:HttpClient) { }


   get token(): string {
      return localStorage.getItem('token') || '';
    }
  
    get headers() {
      return {
        headers: {
          'x-token': this.token
        }
      }
    }
    
    get locationId():string {
      return localStorage.getItem('locationId') || '';
    }
    

  getNotifications(){
 return this.http.get(`${url}notifications?locationId=${this.locationId}`);
  }

  getAutorizations(){
    return this.http.get(`${url}authorizations`)
  }
  putAutoriza(id:any){
    return this.http.put(`${url}authorizations/autorizar/${id}`,{});
  }
  putInvalido(id:any){
    return this.http.put(`${url}authorizations/autorizar/invalid/${id}`,{});
  }

  getUsersNotifications(){
    return this.http.get(`${url}notifications/users`,this.headers);
  }
  saveUsersNotifications(payload:any){
    return this.http.post(`${url}notifications/users`,payload,this.headers);
  }
  removeUsersNotifications(id:string): Observable<any> {
    return this.http.delete(`${url}notifications/users/${id}`,this.headers);
  }
  activeUsersNotifications(id:string): Observable<any> {
    return this.http.put(`${url}notifications/users/${id}`,{},this.headers);
  }
  getConfigNotifications(): Observable<any> {
    return this.http.get(`${url}notifications/config`,this.headers);
  }

  saveConfigNotifications(payload: any): Observable<any> {
    return this.http.post(`${url}notifications/config`, payload);
  }
}
